import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-paginate';
import ConsultantSearchCard from '../ConsultantSearchCard';
import NoSearchResults from './NoSearchResults';
import LoadingIndicator from './LoadingSearchIndicator';
var SearchResultContainer = /*#__PURE__*/function (_PureComponent) {
  function SearchResultContainer(props) {
    var _this;
    _classCallCheck(this, SearchResultContainer);
    _this = _callSuper(this, SearchResultContainer, [props]);
    _this.renderConsultantCards = _this.renderConsultantCards.bind(_this);
    _this.handlePageClick = _this.handlePageClick.bind(_this);
    return _this;
  }
  _inherits(SearchResultContainer, _PureComponent);
  return _createClass(SearchResultContainer, [{
    key: "handlePageClick",
    value: function handlePageClick(_ref) {
      var selected = _ref.selected;
      var setCurrentPage = this.props.setCurrentPage;
      setCurrentPage(selected + 1);
    }
  }, {
    key: "renderConsultantCards",
    value: function renderConsultantCards() {
      var _this$props = this.props,
        consultants = _this$props.consultants,
        location = _this$props.location,
        csrfToken = _this$props.csrfToken,
        workLocationOptions = _this$props.workLocationOptions,
        durationOptions = _this$props.durationOptions,
        timePerWeekOptions = _this$props.timePerWeekOptions,
        query = _this$props.query,
        inviteUrl = _this$props.inviteUrl,
        inviterEmailDomain = _this$props.inviterEmailDomain,
        viewingAsEmployer = _this$props.viewingAsEmployer;
      return consultants.map(function (consultant) {
        return /*#__PURE__*/React.createElement(ConsultantSearchCard, {
          key: consultant.id,
          consultant: consultant,
          location: location,
          csrfToken: csrfToken,
          workLocationOptions: workLocationOptions,
          durationOptions: durationOptions,
          timePerWeekOptions: timePerWeekOptions,
          query: query,
          inviteUrl: inviteUrl,
          inviterEmailDomain: inviterEmailDomain,
          viewingAsEmployer: viewingAsEmployer
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        loading = _this$props2.loading,
        consultants = _this$props2.consultants,
        currentPage = _this$props2.currentPage,
        csrfToken = _this$props2.csrfToken,
        totalPages = _this$props2.totalPages;
      if (loading) {
        return /*#__PURE__*/React.createElement(LoadingIndicator, null);
      }
      if (consultants.length > 0) {
        return /*#__PURE__*/React.createElement("div", null, this.renderConsultantCards(), totalPages > 1 && /*#__PURE__*/React.createElement(Pagination, {
          previousLabel: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-chevron-left"
          }), "\xA0\xA0Prev"),
          nextLabel: /*#__PURE__*/React.createElement("div", null, "Next\xA0\xA0", /*#__PURE__*/React.createElement("i", {
            className: "fa fa-chevron-right"
          })),
          breakLabel: "...",
          breakClassName: "break-me",
          currentPage: currentPage,
          pageCount: totalPages,
          onPageChange: this.handlePageClick,
          containerClassName: "pagination",
          activeClassName: "active",
          marginPagesDisplayed: 1
        }));
      }
      return /*#__PURE__*/React.createElement(NoSearchResults, {
        csrfToken: csrfToken
      });
    }
  }]);
}(PureComponent);
SearchResultContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  consultants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]).isRequired,
  query: PropTypes.number,
  inviteUrl: PropTypes.string.isRequired,
  inviterEmailDomain: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  viewingAsEmployer: PropTypes.bool,
  totalPages: PropTypes.number.isRequired
};
SearchResultContainer.defaultProps = {
  query: '',
  viewingAsEmployer: true
};
export default SearchResultContainer;